export default __webpack_public_path__ + "static/media/homeButton.d245168e.png";